
import * as React from "react";
import {Api} from "../../lib/Api";
import Header from "../Header";
import Footer from "../Footer";
import OrderStatusLabel from "./OrderStatusLabel";
import OrderButton from "./order/OrderButton";
import NewOffer from "./order/NewOffer";


interface IShowOrderProps {
    order: any
    setUrl:any
}

interface IShowOrderState {
}

export default class ShowOrder extends React.Component<IShowOrderProps, IShowOrderState>{

    constructor(props:IShowOrderProps){
        super(props);
        this.state = {

        };


    }


    render() {
        let order = this.props.order;
        console.log(order);
        return (
            <div className="user-show-order">
                <Header
                    setUrl={this.props.setUrl}
                />
                <section className="content_section container show-order">
                    <section className="dashboard_menu">
                        <div className="row">
                            <div className = "col-md-12">
                                <div className="order">
                                    <div className = "main-content">
                                        <div className = "profile-image">
                                            <div className = "image">
                                                {
                                                    order.offer.creator.photos?.profilePhoto.length > 0 &&
                                                        <img src={order.offer.creator.photos?.profilePhoto} />
                                                }

                                            </div>
                                        </div>

                                        <div className = "content">
                                            <p className="name">{order.offer.creator.name}</p>
                                            <p className="offer-type">{order.offer.offerType.name}</p>
                                            <p className="offer-hours">{order.hours} hours</p>
                                            {
                                                order.offer.creator.rateing > 0 &&
                                                <span className="rateing_star_inline_box">
                                                    { order.offer.creator.rateing >= 1?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                                    { order.offer.creator.rateing >= 2?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                                    { order.offer.creator.rateing >= 3?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                                    { order.offer.creator.rateing >= 4?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                                    { order.offer.creator.rateing >= 5?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                                </span>
                                            }
                                            <hr/>
                                            <p className = "price">{order.price} {order.currency}</p>
                                        </div>
                                    </div>

                                </div>
                                <OrderStatusLabel order={order} />
                                <NewOffer order={order} setUrl={this.props.setUrl} />
                                <OrderButton order={order} setUrl = {this.props.setUrl} />
                            </div>

                        </div>
                    </section>
                </section>

                <Footer homePageMode={Api.isFrontUser()} setUrl={this.props.setUrl}></Footer>

            </div>
        );
    }
}
